import React from 'react'
import Navbar from '../../components/Navbar'
import Footer from "../../components/Footer";
import TreatmentsTemplate from '../../components/Treatments-template'
import ortoImg from '../media/orto.jpeg'
import orto2Img from '../media/orto.jpg'
import {useTranslation, Trans} from 'react-i18next'

export default function Orto() {
    const { t } = useTranslation();

    return (
        <>
            <Navbar></Navbar>
            <TreatmentsTemplate 
            backgroundImage = {ortoImg}
            title = {t('ortoTitle')}
            paragraph = {t('ortoSubtitle')}
            addClass = "min-width" 
            mediaContent = 
            {
            `# ${t('ortoTitle2')}
***  

${t('ortoParaf')}


![](${orto2Img})
            `
            }
             >
            
            </TreatmentsTemplate>
            <Footer></Footer>
        </>
    )
}
